import Button from '@/presentation/components/elements/Button';
import { Address } from 'nftx.js';
import { Dispatch, useEffect } from 'react';
import { IncreaseLiquidityDetails } from '../types';
import { useForm, useWatch } from 'react-hook-form';
import { SelectPoolFormFields } from '@/presentation/components/forms/CreatePositionForms/SelectPoolForm';
import UsingForm from '@/presentation/components/forms/CreatePositionForms/UsingForm';

type UsingStepProps = {
  collection: Address;
  collectionName: string;
  vaultId: string;
  icon?: string;
  symbol: string;
  dispatch: Dispatch<Partial<IncreaseLiquidityDetails>>;
  onSubmit: (...args: any) => void;
  state: IncreaseLiquidityDetails;
};

const UsingStep = ({
  collection,
  collectionName,
  symbol,
  icon,
  dispatch,
  onSubmit,
  vaultId,
  state,
}: UsingStepProps) => {
  const { control, handleSubmit } = useForm<SelectPoolFormFields>({
    defaultValues: { using: state.using },
  });
  const { using = state.using } = useWatch({ control });

  useEffect(() => {
    dispatch({ using, items: [], tokenAmount: undefined });
  }, [dispatch, using]);

  const onUsingFormSubmit = handleSubmit(({ using }) => {
    // dispatch({ using });
    onSubmit();
  });

  return (
    <form onSubmit={onUsingFormSubmit}>
      <UsingForm
        collection={collection}
        collectionName={collectionName}
        control={control}
        size="normal"
        symbol={symbol}
        icon={icon}
        vaultId={vaultId}
        using={using}
      />
      <Button size="xl" type="submit" className="w-full mt-6">
        {'Next'}
      </Button>
    </form>
  );
};

export default UsingStep;
